module.exports = __webpack_public_path__ + "static/media/Байзаев С.,  Баротов  Р.Н..e67d45cc.pdf";